import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';

export const merchantRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/merchant',
  component: lazyRouteComponent(() => import('@/pages/merchant')),
});

export const addMerchantRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/merchant/create',
  component: lazyRouteComponent(() => import('@/pages/merchant/create')),
});

export const detailMerchantRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/merchant/$id',
  component: lazyRouteComponent(() => import('@/pages/merchant/detail')),
});

export const editMerchantRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/merchant/$id/edit',
  component: lazyRouteComponent(() => import('@/pages/merchant/edit')),
});
